import { Close } from '@material-ui/icons'
import { Dialog, DialogTitle } from '@mui/material'
import moment from 'moment'
import React from 'react'

const AcknowledgeModal = ({ open, onClose, itemData }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <DialogTitle fontSize={16}>Detail Acknowledgement</DialogTitle>
        <Close onClick={onClose} />
      </div>
      <div style={{ padding: '0 25px 20px 25px' }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <img src={itemData.image} style={{ width: 100, height: 100, objectFit: 'cover' }} />
          <div>
            <p style={{ marginBottom: 8 }}>{itemData.productName}</p>
            <p style={{ color: '#555' }}>MID: {itemData.mid}</p>
          </div>
        </div>
        <table style={{ width: '100%', fontSize: 14, borderCollapse: 'collapse', marginTop: 20 }}>
          <tbody>
            <tr>
              <td style={{ padding: '8px 0', borderBottom: '1px solid #ddd', width: '50%' }}>
                Date
              </td>
              <td style={{ padding: '8px 0', borderBottom: '1px solid #ddd', width: '50%' }}>
                Qty
              </td>
            </tr>
            {itemData.order_item_acknowledges &&
              itemData.order_item_acknowledges.map((acknowledge, index) => (
                <tr key={index}>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid #ddd' }}>
                    {moment(acknowledge.date).format('DD MMM YYYY')}
                  </td>
                  <td style={{ padding: '8px 0', borderBottom: '1px solid #ddd' }}>
                    {acknowledge.quantity}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </Dialog>
  )
}

export default AcknowledgeModal
